import { render, staticRenderFns } from "./risks.vue?vue&type=template&id=02e8cd43&scoped=true"
import script from "./risks.vue?vue&type=script&lang=js"
export * from "./risks.vue?vue&type=script&lang=js"
import style0 from "./risks.vue?vue&type=style&index=0&id=02e8cd43&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../../../../../opt/deploy_node_modules/ailaworld/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02e8cd43",
  null
  
)

export default component.exports